import { createTranslations } from '@npco/utils-translations'

export const setupFlowStartStageTranslations = createTranslations({
  title: 'Welcome to Zeller',
  description:
    'Your new Zeller Account gives you a suite of tools to power all of your business finances.',
})
